import { useTranslation } from './LanguageContext';
import { fr, enGB, es, pt, it, de, zhCN, arSA } from 'date-fns/locale';
const dateLocales = { fr, en: enGB, es, pt, it, de, zh: zhCN, ar: arSA };
export function useAppTranslation() {
  const { t, ...language } = useTranslation();
  return { ...language, tr: t, dateLocale: dateLocales[language.language] };
}
